/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

import * as React from 'react';

export default function applyNesting(
  children: React.ReactNode | React.ReactNodeArray,
) {
  return React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return !child || typeof child === 'string'
        ? child
        : React.cloneElement(child, { inline: true, ...child.props });
    }
    return child;
  });
}
